import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'gr-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'gr-empty-state flex w-full items-center justify-center',
    '[class.h-full]': 'fill()',
    '[class.min-h-full]': 'fill()',
  },
  template: `
    <div class="flex flex-col items-center justify-center text-center gap-3 p-6">
      @if (icon()) {
        <span class="material-icons-outlined gr-empty-state__icon" aria-hidden="true">{{
          icon()
        }}</span>
      }
      @if (heading()) {
        <p class="gr-empty-state__heading m-0">{{ heading() }}</p>
      }
      @if (description()) {
        <p class="gr-empty-state__description m-0">{{ description() }}</p>
      }
      <div class="flex items-center gap-2 mt-2 empty:hidden">
        <ng-content />
      </div>
    </div>
  `,
})
export class GrEmptyStateComponent {
  readonly icon = input<string>('');
  readonly heading = input<string>('');
  readonly description = input<string>('');
  readonly fill = input<boolean>(false);
}
